export const en = {
    adaptive: 'Adaptive creative',
    'adaptive-disclaimer': 'The new adaptive ad automatically adjusts to fit the chosen ad block on the ad platform.',
    'adaptive-info':
        'Your creative image must meet the following requirements: maximum resolution of 1500x800 pixels (larger images will be compressed) and maximum image size after compression of 512 KB.',
    'apply-adaptive': 'Try it out!',
    'create-banners': 'Create',
    'empty-message':
        'No ideas for creatives here yet. Enter the URL of a page and the Ad Builder will generate ides for creatives based on the content of that page.',
    'progress-message': 'Downloading page content',
    'progress-message1': 'Still downloading page content',
    'progress-message2':
        "Still downloading page content. It's possible many ideas are being created, or that the site is slow to respond.",
    'url-placeholder': 'URL of your site'
};
